// src/pages/yachts/special-offers/buildOfferPayload.js
// Shapes the offer form values into the API payload. Shared by the create and edit
// containers so the two cannot drift.

import moment from 'moment';

const TIERED_TYPES = ['tiered_discount', 'package'];

const lower = (v) => (v ? String(v).trim().toLowerCase() : v);

export default function buildOfferPayload(values, yachtId) {
    const payload = { ...values, yacht_id: yachtId };

    ['publish_start_date', 'publish_end_date'].forEach((k) => {
        if (payload[k]) payload[k] = moment(payload[k]).toISOString();
    });
    ['date_from', 'date_to', 'booking_window_start', 'booking_window_end'].forEach((k) => {
        if (payload[k]) payload[k] = String(payload[k]).slice(0, 10);
    });

    // Currencies are compared verbatim against lower-case rate currencies.
    payload.discount_amount_currency = lower(payload.discount_amount_currency);

    // Tiers left behind by a previous offer type are rejected by the API.
    if (TIERED_TYPES.includes(payload.offer_type)) {
        payload.tiers = (payload.tiers || []).map((t) => ({
            ...t,
            package_currency: lower(t.package_currency)
        }));
    } else {
        payload.tiers = [];
    }

    payload.location_ids = Array.isArray(payload.location_ids)
        ? payload.location_ids.map(Number)
        : [];
    payload.allow_partial_application = !!payload.allow_partial_application;

    return payload;
}
